export const getCsrfToken = (): string =>
  typeof document !== 'undefined'
    ? document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
    : '';
